




























































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { FuelRate } from '@/models/rateTariff/FuelRate';

import fuelRatesService from '@/services/FuelRateService';
import exportService from '@/services/ExportService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      term: '',
      currentPage: 1,
      pageSize: 10,
      loading: false,
      snackbar: false,
      snackbarText: '',
      showPaging: false,
      showEditForm: false,
      showHistoryView: false,
      availableTabs: ['Active', 'Expired'],
      currentTab: 'Active',
      searchIndex: 0,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    csvExport() {
      exportService.csvDownload(this.all, 'Fuel Rates');
    },
    fetch() {
      this.loading = true;

      fuelRatesService.getAll().then((x: FuelRate[]) => {
        this.$store.commit('fuelRates/setRates', x);

        this.applyFilters(this.term);
        this.loading = false;
      });
    },
    getTabCounter(tab) {
      const currentDate = moment();
      if (tab === 'Active') {
        return this.all.filter((x) => moment(x.effEndDate).isAfter(currentDate))
          .length;
      }

      return this.all.filter((x) => moment(x.effEndDate).isBefore(currentDate))
        .length;
    },
    applyFilters(x) {
      this.term = x;
      let items = this.all;
      const currentDate = moment();

      if (this.currentTab == 'Active') {
        items = items.filter((x) => moment(x.effEndDate).isAfter(currentDate));
      } else {
        items = items.filter((x) => moment(x.effEndDate).isBefore(currentDate));
      }

      if (this.term) {
        const q = this.term.toLowerCase();
        items = items.filter(
          (x) =>
            x.contractId?.toString().toLowerCase().includes(q) ||
            x.description?.toLowerCase().includes(q) ||
            x.carrierId?.toLowerCase().includes(q) ||
            x.carrierName?.toLowerCase().includes(q)
        );
      }

      this.$store.commit('fuelRates/setFilteredRates', items);

      const page = items.slice(0, this.pageSize);
      this.$store.commit('fuelRates/setPage', page);

      this.searchIndex++;
    },
    pageChange(newPage) {
      let page = this.filteredRates.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('fuelRates/setPage', page);
    },
    tabClicked(tab: string) {
      this.currentTab = tab;
      this.applyFilters();
    },
    edit(item) {
      this.$store.commit('fuelRates/setRateToEdit', item);
      this.showEditForm = true;
    },
    viewHistory() {
      this.showHistoryView = true;
    },
    fuelRateSaved() {
      this.fetch();

      this.showEditForm = false;
      this.snackbarText = 'Fuel rate has been saved successfully';
      this.snackbar = true;
    },
  },
  computed: {
    ...mapGetters('fuelRates', ['all', 'page', 'filteredRates']),
    pagingLength() {
      return Math.ceil(this.filteredRates.length / this.pageSize);
    },
  },
});
